import React, { useState } from "react";
import { suppDropdown } from "./NavItems";
import { Link } from "react-router-dom";
import "./Dropdown.css";

function SuppDropdown() {
  const [suppdropdown, setSuppDropdown] = useState(false);

  return (
    <>
      <ul
        className={suppdropdown ? "supp-submenu clicked" : "supp-submenu"}
        onClick={() => setSuppDropdown(!suppdropdown)} > {
        suppDropdown.map((item) => {
          return (
            <li key={item.id}>
              <Link to={item.path} className={item.cName} onClick={() => setSuppDropdown(false)}>
                {item.title}
              </Link>
            </li>
          );
        })
      } </ul>
    </>
  );
}

export default SuppDropdown;
